var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dropzone from "react-dropzone";
import styled from "styled-components";
var StyledDropzone = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", "px;\n  border: 2px dashed ", ";\n"], ["\n  padding: ", "px;\n  border: 2px dashed ", ";\n"])), function (props) { return props.theme.spacing * 4; }, function (props) { return props.theme.color.gray; });
export default (function (props) {
    return (_jsx(Dropzone, __assign({ onDrop: props.onDrop }, { children: function (_a) {
            var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
            return (
            // @ts-ignore
            _jsxs(StyledDropzone, __assign({}, getRootProps(), { children: [_jsx("input", __assign({}, getInputProps())), props.children] })));
        } })));
});
var templateObject_1;
//# sourceMappingURL=index.js.map